import { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import useValidator from "../../../hooks/useValidator";
import { toast } from "react-toastify";
import Button from "../../../components/Button";
import { Grid } from "@mui/material";
import Modal from "../../../components/Modal";
import useStyles from "../styles";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";

const EMPLOYEES_ENDPOINT = "/api/v1/employees";
const CLASS_ENDPOINT = "/api/v1/class";

const classmodal = ({ isOpen, onClose, onSuccess }) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [classValidator, showClassValidator] = useValidator();
  const [showvirtualoption, setShowVirtualOption] = useState(false);
  const [employeeData, setEmployeesData] = useState([]);
  const [classForm, setClassForm] = useState({
    class_name: "",
    class_teacher_id: "",
    class_type: "",
    meeting_link: "",
    start_time: "",
    end_time: "",
    virtual_class_date: "",
    attendees: []
  });
  /**
 * Handles input change for the class creation form.
 * Updates the `classForm` state.
 *
 * @param {object} e - Event object from input
 */
  const handleClassChange = (e) => {
    const { name, value } = e.target;
    setClassForm({ ...classForm, [name]: value });
  };

  /**
 * Submits the new class form to create a new class.
 */
  const handleCreateClass = () => {
    if (classValidator.allValid()) {
      setIsLoading(true);
      httprequest.post(CLASS_ENDPOINT, classForm).then((res) => {
        setIsLoading(false);
        setClassForm({ ...classForm, class_name: "", class_teacher_id: "", class_type: "", meeting_link: "", start_time: "", end_time: "", virtual_class_date: "", attendees: [] });
        const toastId = toast.success(res?.data?.message, {
          autoClose: 3000
        });

        setTimeout(() => {
          toast.dismiss(toastId);
          if (onSuccess) onSuccess();
          // window.location.reload();
        }, 3000);
      }).catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showClassValidator(true);
    }
  };

  /**
 * Fetches all employees for class assignment.
 */
  const getAllEmployees = () => {
    httprequest.get(EMPLOYEES_ENDPOINT).then((res) => {
      setEmployeesData(res?.data?.data?.employees);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  /**
 * Handles the selection change for the class type dropdown.
 * Shows or hides virtual options based on selection.
 * @param {Object} e - The change event from the select input.
 */
  const handleSelectChange = (e) => {
    const { value } = e.target;
    setClassForm({ ...classForm, class_type: value });
    setShowVirtualOption(e.target.value === "virtual");
  };

  /**
 * On initial page load, fetch all classes and employees.
 */
  useEffect(() => {
    getAllEmployees();
  }, []);

  /**
 * Destructure class form fields from `classForm` state.
 * Used to populate input values or send data to API.
 */
  const { class_name, class_teacher_id, class_type, meeting_link, start_time, end_time, virtual_class_date } = classForm;

  return (
    <div>
      {/* Create a Class Modal */}
      <Modal
        title="Create a Class"
        subtitle={
          <div>Create a class and assign a teacher to it
          </div>}
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup
                  label="Class Name"
                  margin="normal"
                  required
                  placeHolder="Enter class name"
                  inputType="text"
                  onChange={handleClassChange}
                  value={class_name}
                  inputName="class_name"
                />
                {classValidator.message("class_name", class_name, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <SelectGroup required label="Class Teacher" children={
                  <select onChange={handleClassChange} name="class_teacher_id" value={class_teacher_id}>
                    <option value="">--- Select ---</option>
                    {employeeData?.map((employee) => {
                      return (
                        <option key={employee?.employee_id} value={employee?.employee_id}>{employee?.first_name}{" "}{employee?.last_name}</option>
                      );
                    })}
                  </select>
                }
                />
                {classValidator.message("class_teacher_id", class_teacher_id, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <SelectGroup required label="Class Type" children={
                  <select name="class_type" value={class_type} onChange={handleSelectChange}>
                    <option value="select">--- Select ---</option>
                    <option value="virtual">Virtual</option>
                    <option value="physical">Physical</option>
                  </select>
                }
                />
                {classValidator.message("class_type", class_type, "required")}
              </Grid>
              { showvirtualoption && (
                <>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <InputGroup
                      label="Start Time"
                      margin="normal"
                      required
                      inputType="time"
                      inputName="start_time"
                      value={start_time}
                      onChange={handleClassChange}
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <InputGroup
                      label="End Time"
                      margin="normal"
                      required
                      inputType="time"
                      inputName="end_time"
                      value={end_time}
                      onChange={handleClassChange}
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <InputGroup
                      label="Virtual Date"
                      margin="normal"
                      required
                      inputType="date"
                      inputName="virtual_class_date"
                      value={virtual_class_date}
                      onChange={handleClassChange}
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <InputGroup
                      label="Meeting Link"
                      margin="normal"
                      required
                      inputType="text"
                      inputName="meeting_link"
                      value={meeting_link}
                      onChange={handleClassChange}
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Add Email(s)"
                      margin="normal"
                      required
                      placeHolder="Add Emails"
                      inputType="text"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </>
        }
        modalFooter={
          <>
            <div className={classes.modalFooterBtn}>
              <Button variant="primary" buttonSize="full" color="btndefault" buttonName="Create Class" onClick={handleCreateClass} isLoading={isLoading} />
            </div>
          </>
        }
        isopen={isOpen}
        closeModal={onClose}
      />
    </div>
  );
};

export default classmodal;
